import React from 'react';
import { openFranchiseFinmodelForm } from './franchiseConstants';

export function PartnersSection() {
  const ok = (
    <svg width="32" height="21" viewBox="0 0 32 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.57068 7.91489L12.6598 16.8701L29.5707 1.87012" stroke="#FF0000" strokeWidth="5" />
    </svg>
  );
  return (
    <section id="s-partners" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-partners" data-reveal>
          <div className="franchise-partners__banner">
            <div>Кому подходит франшиза SUSHIBOX</div>
            <div>Мы строим долгосрочные партнёрства и помогаем развивать бизнес <br /> в каждом городе.</div>
          </div>
          <div className="franchise-partners__l-side">
            <img src="/assets/media/franchise/partners-section/partners.jpg" alt="Partners" />
            <div className="franchise-partners__l-side__conclusion">Мы ищем <br /> не просто <br /> инвесторов — <br />  мы ищем <br /> партнёров</div>
            <div className="franchise-partners__l-side__text">Узнали себя? Давайте обсудим <br /> открытие в вашем городе.</div>
          </div>
          <div className="franchise-partners__r-side">
            <div className="franchise-partners__r-side__content">
              <div>
                <div>{ok}</div>
                <div>Вы хотите открыть бизнес <br /> в своем городе</div>
              </div>
              <div>
                <div>{ok}</div>
                <div>Вы цените системный подход <br /> и понятные процессы</div>
              </div>
              <div>
                <div>{ok}</div>
                <div>Вы готовы участвовать в развитии <br /> компании</div>
              </div>
              <div>
                <div>{ok}</div>
                <div>Вам важны качество продукта <br /> и уровень сервиса</div>
              </div>
              <div>
                <div>{ok}</div>
                <div>Вы хотите строить бизнес надолго, <br /> а не искать быстрный заработок</div>
              </div>
            </div>
            <button type="button" className="franchise-partners__r-side__button" onClick={openFranchiseFinmodelForm()}>Обсудить открытие <br /> в моём городе</button>
          </div>
        </div>
      </div>
    </section>
  );
}
